import { defineStore } from "pinia";
import { STATE_KEYS } from "%/dynamic-components/render-engine/helpers/subscription-action-button";

const PREVIEW_STATES = Object.values(STATE_KEYS);

export const useSubscriptionActionPreviewStore = defineStore("subscription-action-preview-store", {
  state: () => ({
    previewState: STATE_KEYS.SUBSCRIBE,
  }),
  actions: {
    setPreviewState(state) {
      this.previewState = PREVIEW_STATES.includes(state) ? state : STATE_KEYS.SUBSCRIBE;
    },
  },
});
